import { Injectable } from "@angular/core";
import { BehaviorSubject } from 'rxjs';

@Injectable(
  {providedIn: "root"}
)
export class LoadingPageService {
  isLoading = new BehaviorSubject(false);
}
